import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../components/Button'
import Card from '../../components/Card'
import Input from '../../components/Input'
import Link from '../../components/Link'
import Text from '../../components/Text'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import AuthLayout from '../../layouts/AuthLayout'
import patient from '../../stores/patient'
import request from '../../utils/request'

const CounselorLoginWrap = styled.div`
  margin: 2rem 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

const LinkBox = styled.div`
  display: flex;
  justify-content: flex-end;
`

@observer
export default class PatientLogin extends Component {
  @observable loading = false
  @observable error = false
  @observable passphraseShown = false

  @observable
  fields = {
    loginID: '',
    loginPassphrase: '',
  }

  @action
  setField = event => {
    this.error = false
    this.fields[event.target.name] = event.target.value
  }

  @action
  setLoading = () => {
    this.loading = true
    this.error = false
  }

  @action
  setError = () => {
    this.loading = false
    this.error = true
  }

  @action
  togglePassphraseShown = () => {
    this.passphraseShown = !this.passphraseShown
  }

  submit = async event => {
    const { history } = this.props
    event.preventDefault()
    this.setLoading()
    const req = await request('/api/patientAuth/login', this.fields)

    if (req.success) {
      patient.setReadonlyFields(req.data.patient)
      history.push('/patient-session/learn')
    } else {
      this.setError()
    }
  }

  render() {
    return (
      <CheckLoginStatus loggedInRedirect="/dashboard">
        <AuthLayout>
          <Card>
            {this.error && <Card.ErrorMessage />}
            <form onSubmit={this.submit}>
              <Card.Pad>
                <Input
                  label="titles.loginID"
                  value={this.fields.loginID}
                  onChange={this.setField}
                  disabled={this.loading}
                  name="loginID"
                />
                <Input
                  label="titles.passphrase"
                  value={this.fields.loginPassphrase}
                  onChange={this.setField}
                  disabled={this.loading}
                  type={this.passphraseShown ? 'text' : 'password'}
                  name="loginPassphrase"
                />
                <LinkBox>
                  <Link
                    str={this.passphraseShown ? 'titles.hidePassphrase' : 'titles.showPassphrase'}
                    to="#"
                    onClick={this.togglePassphraseShown}
                  />
                </LinkBox>
              </Card.Pad>
              <Card.Divider />
              <Card.Pad>
                <Button
                  color="blue"
                  str="titles.signIn"
                  disabled={this.loading}
                  type="submit"
                />
              </Card.Pad>
            </form>
          </Card>
          <CounselorLoginWrap>
            <Text str="prose.areYouACounselor" />&nbsp;
            <Link str="titles.clickHere" to="/" />
          </CounselorLoginWrap>
          <CounselorLoginWrap>
            <Link str="titles.emailSupport" href="mailto:glaucomaeyeguide@umich.edu" />
          </CounselorLoginWrap>
        </AuthLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/PatientLogin/index.js